<template>
	<div class="notice-list">
		<div class="notice-item" v-for="item in props.list" :key="item.wid" @click="goDetail(item)">
			<div class="content" v-if="!props.keyword">
				{{ item.title }}
			</div>
      <div class="content" v-else>
        <HighLight :keyword="props.keyword" :text="item.title" />
      </div>
			<div class="date">{{ item.fbrq || item.publish_TIME }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import HighLight from '@/components/HighLight/index.vue'
const router = useRouter()
const props = defineProps<{
	list: Array<any>
  keyword: string
}>()

const goDetail = (item) => {
  console.log(item.fj.length ? JSON.stringify(item.fj) : '[123]')
	router.push({
		path: '/layout/information-detail',
		query: {
			id: item.wid,
			title: item.title,
			date: item.fbrq || item.publish_TIME,
			publisher: item.publisher_NAME,
			depart: item.depart_NAME,
			attachmentStr: typeof item.fj === 'string' ? item.fj : JSON.stringify(item.fj)
		}
	})
}
</script>
<style scoped lang="scss">
.notice-list {
	padding: 0 15px;
	&::-webkit-scrollbar {
		display: none;
	}
	.notice-item {
		background: rgba(189, 58, 54, 0.04);
		border-radius: 5px 5px 5px 5px;
		border-left: 3px solid #bd3a36;
		margin-bottom: $commonMarginAndPadding;
		padding: $commonMarginAndPadding 15px;
		.content {
			font-size: $commonFontSize;
			line-height: 24px;
			//@include more-ellipsis();
		}
		.date {
			color: #7d7e80;
			font-size: $miniFontSize;
			text-align: right;
			margin-top: 3px;
		}
	}
}
</style>
